export default "__VITE_ASSET__DLNawAYx__"